import NDA from "../components/NDA";
import WebApp from "../components/WebApp";

const NDAPage = () => {
  return (
    <WebApp>
      <NDA></NDA>
    </WebApp>
  );
};


export default NDAPage;